import React from "react";
import { Carousel, Image } from "react-bootstrap";
import { getPromotionsByTag } from "../../api/Api";
import ResponsiveEmbed from "react-bootstrap/ResponsiveEmbed";

class Promotion extends React.Component {
  constructor(props) {
    super(props);

    this.promoRef = React.createRef();

    this.state = {
      tagSelected: this.props.item.tag,
      promos: [],
      textPromo: [],
      actualWidth: 0,
      carouseleInterval: 10000,
      activeIndex: 0,
    };
  }

  componentDidMount() {
    this.getPromo();
    this.setWidth();

    this.interval = setInterval(this.getPromo, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearTimeout(this.restartCarouselTimeout);
  }

  setWidth() {
    this.props.layout.forEach((element) => {
      if (element.i === this.props.item.i) {
        this.setState({
          actualWidth: element.w * 10,
        });
      }
    });
  }


isVideoSlide = (index) => {
  const imageCount = this.state.promos.filter(
    promo => promo.conf.picture_landscape
  ).length;

  const videoCount = this.state.promos.filter(
    promo => promo.conf.video_landscape
  ).length;

  return (
    index >= imageCount &&
    index < imageCount + videoCount
  );
};



goToNextSlide = () => {
  const totalSlides =
    this.state.promos.filter(
      promo => promo.conf.picture_landscape
    ).length +
    this.state.promos.filter(
      promo => promo.conf.video_landscape
    ).length +
    this.state.textPromo.length;

  if (totalSlides === 0) {
    return;
  }

  this.setState(prevState => ({
    activeIndex:
      (prevState.activeIndex + 1) % totalSlides,
  }));
};

  getPromo = () => {
    getPromotionsByTag(
      this.props.currentDisplay,
      this.state.tagSelected
    ).then((res) => {
      if (res == null) {
        this.setState({
          promos: [],
          textPromo: [],
        });
      } else if (res[0]) {
        this.filterPromoDisabled(res);
        this.getTextPromo();
      }
    });
  };

  getTextPromo = () => {
    const textPromofetch = [];
    const context = this;

    this.state.promos
      .filter(function (value) {
        return value.conf.text_file !== "";
      })
      .map(function (item) {
        const url = item.conf.text_file;

        return fetch(url)
          .then((response) => response.json())
          .then((jsonData) => {
            textPromofetch.push(jsonData);

            context.setState({
              textPromo: textPromofetch,
            });
          });
      });
  };

  filterPromoDisabled(promotions) {
    const promotionsActive = [];

    promotions.forEach((promotion) => {
      let isPromoActive = true;

      isPromoActive = !isPromoActive
        ? false
        : this.verifyTime(
            promotion.promotion.conf.starts_time_at,
            promotion.promotion.conf.ends_time_at
          );

      isPromoActive = !isPromoActive
        ? false
        : this.verifyTrigger(promotion.restaurants);

      if (isPromoActive) {
        promotionsActive.push(promotion.promotion);
      }
    });

    this.setState({
      promos: promotionsActive,
    });
  }

  verifyDate(start, end) {
    const today = new Date();

    start = new Date(start);
    end = new Date(end);

    return start < today && today < end;
  }

  verifyTime(start, end) {
    const now = new Date();

    const minutes = now.getMinutes();

    const hours =
      now.getHours() < 10
        ? "0" + now.getHours()
        : now.getHours();

    start =
      start.split(":")[0] +
      "" +
      start.split(":")[0];

    const currentTime = hours + "" + minutes;

    end =
      end.split(":")[0] +
      "" +
      end.split(":")[0];

    return start < currentTime && currentTime < end;
  }

  verifyTrigger(restaurants) {
    let isActive = true;

    if (restaurants) {
      restaurants.forEach((restaurant) => {
        if (
          this.props.device.place_id ===
          restaurant.place_id
        ) {
          if (restaurant.region_id) {
            if (!restaurant.level_reached) {
              isActive = false;
            }
          }
        }
      });
    }

    return isActive;
  }

  /**
   * Chiamata dopo il completamento del cambio slide.
   */
videoSlide = () => {
  if (!this.promoRef.current) {
    return;
  }

  const videos =
    this.promoRef.current.querySelectorAll("video");

  videos.forEach(video => {
    const item = video.closest(".carousel-item");

    if (
      !item ||
      !item.classList.contains("active")
    ) {
      video.pause();
      video.currentTime = 0;
    }
  });

  const activeVideo =
    this.promoRef.current.querySelector(
      ".carousel-item.active video"
    );

  if (activeVideo) {
    activeVideo.currentTime = 0;
    activeVideo.play().catch(() => {});
  }
};

  /**
   * Quando il video termina, simula il click sul controllo Next.
   */
handleVideoEnded = (event) => {
  const video = event.currentTarget;
  const carouselItem = video.closest(".carousel-item");

  if (
    !carouselItem ||
    !carouselItem.classList.contains("active")
  ) {
    return;
  }

  this.goToNextSlide();

  clearTimeout(this.restartCarouselTimeout);

  this.restartCarouselTimeout = setTimeout(() => {
    this.setState({
      carouseleInterval: 10000,
    });
  }, 800);
};
  render() {
    const that = this;
    let arePromoHorizontal = false;

    this.state.promos.forEach((promo) => {
      if (
        promo.conf.picture_landscape !== "" ||
        promo.conf.video_landscape !== "" ||
        promo.conf.text_file !== ""
      ) {
        arePromoHorizontal = true;
      }
    });

    return (
      <>
        {arePromoHorizontal ? (
          <div
            className="promo"
            ref={this.promoRef}
          >
          <Carousel
            controls={false}
            indicators={false}
            interval={this.state.carouseleInterval}
            activeIndex={this.state.activeIndex}
            onSelect={(selectedIndex) => {
              const isVideo = this.isVideoSlide(selectedIndex);

              clearTimeout(this.restartCarouselTimeout);

              this.setState({
                activeIndex: selectedIndex,
                carouseleInterval: isVideo ? null : 10000,
              });
            }}
            onSlid={this.videoSlide}
          >
              {/* IF IMAGE */}
              {this.state.promos
                .filter(function (value) {
                  return value.conf.picture_landscape;
                })
                .map(function (item, i) {
                  return (
                    <Carousel.Item
                      key={`image-${i}`}
                    >
                      <div className="slide-demo">
                        <Image
                          src={
                            item.conf
                              .picture_landscape
                          }
                          className="imageCarousel"
                        />
                      </div>
                    </Carousel.Item>
                  );
                })}

              {/* IF VIDEO */}
              {this.state.promos
                .filter(function (value) {
                  return value.conf.video_landscape;
                })
                .map(function (item, i) {
                  return (
                    <Carousel.Item
                      key={`video-${i}`}
                    >
                      <div className="video-section">
                        <ResponsiveEmbed
                          aspectRatio="16by9"
                          className="video-section"
                        >
                          <video
                            className="video-fluid"
                            muted
                            loop={false}
                            onEnded={that.handleVideoEnded}
                          >
                            <source src={item.conf.video_landscape} />
                          </video>
                        </ResponsiveEmbed>
                      </div>
                    </Carousel.Item>
                  );
                })}

              {this.props.width}

              {/* IF TEXT */}
              {this.state.textPromo.map(
                function (promo, i) {
                  return (
                    <Carousel.Item
                      key={`text-${i}`}
                    >
                      <div
                        className="slide-textpromo"
                        style={{
                          backgroundColor:
                            promo.background
                              .backgroundColor,
                        }}
                      >
                        <h1
                          className="textpromo-title"
                          style={{
                            lineHeight:
                              promo.title.lineHeight,
                            wordBreak: "break-word",
                            color:
                              promo.title.color,
                            fontSize:
                              (that.state
                                .actualWidth *
                                promo.title
                                  .fontSize) /
                                promo.background
                                  .widthContainer +
                              "px",
                            fontFamily:
                              promo.title
                                .fontFamily,
                            fontWeight:
                              promo.title.bold,
                            fontStyle:
                              promo.title.italic,
                            textDecoration:
                              promo.title
                                .underline +
                              promo.title
                                .lineThrough,
                            paddingLeft:
                              (that.state
                                .actualWidth *
                                promo.title
                                  .paddingLeftRight) /
                                promo.background
                                  .widthContainer +
                              "px",
                            paddingRight:
                              (that.state
                                .actualWidth *
                                promo.title
                                  .paddingLeftRight) /
                                promo.background
                                  .widthContainer +
                              "px",
                            marginBottom:
                              (that.state
                                .actualWidth *
                                promo.title
                                  .marginBttm) /
                                promo.background
                                  .widthContainer +
                              "px",
                          }}
                        >
                          {promo.title.text}
                        </h1>

                        <p
                          className="textpromo-title"
                          style={{
                            lineHeight:
                              promo.subtitle
                                .lineHeight,
                            wordBreak: "break-word",
                            color:
                              promo.subtitle.color,
                            fontSize:
                              (that.state
                                .actualWidth *
                                promo.subtitle
                                  .fontSize) /
                                promo.background
                                  .widthContainer +
                              "px",
                            fontWeight:
                              promo.subtitle.bold,
                            fontFamily:
                              promo.subtitle
                                .fontFamily,
                            fontStyle:
                              promo.subtitle
                                .italic,
                            textDecoration:
                              promo.subtitle
                                .underline +
                              promo.subtitle
                                .lineThrough,
                            paddingLeft:
                              (that.state
                                .actualWidth *
                                promo.subtitle
                                  .paddingLeftRight) /
                                promo.background
                                  .widthContainer +
                              "px",
                            paddingRight:
                              (that.state
                                .actualWidth *
                                promo.subtitle
                                  .paddingLeftRight) /
                                promo.background
                                  .widthContainer +
                              "px",
                          }}
                        >
                          {promo.subtitle.text}
                        </p>
                      </div>
                    </Carousel.Item>
                  );
                }
              )}
            </Carousel>
          </div>
        ) : null}
      </>
    );
  }
}

export default Promotion;